import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {Application} from '../../../domain/onBoarding/application';
import {Router} from '@angular/router';
import {ApplicationService} from '../../../services/application.service';
import {FormBuilder} from '@angular/forms';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {HttpClient} from '@angular/common/http';
import {ApplicationBody, ApplicationStatus} from '../../../domain/onBoarding/application-body';
import {EContracts} from '../../../enums/EContracts';
import {ToastaService} from 'ngx-toasta';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {ConfigurationService} from '../../../services/configuration.service';
import {DialogService} from 'primeng/dynamicdialog';
import {LocalStorageService} from 'angular-2-local-storage';
import {StorageItem} from '../../../enums/storage-item';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent extends CommonComponent implements OnInit {
  application: Application;
  urlDoc10: string;
  readDoc10 = false;
  contracts = EContracts;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    public configurationService: ConfigurationService,
    protected router: Router,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private localStorage: LocalStorageService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = applicationService.application;
    this.locale = this.locale.substring(0, 2);
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        const language = this.translate.currentLang === 'en' ? 'en' : 'es';
        this.urlDoc10 = `assets/documents/doc10_${language}.pdf`;
      });
  }

  ngOnInit(): void {
    scroll(0, 0);
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    const language = this.translate.currentLang === 'en' ? 'en' : 'es';
    this.urlDoc10 = `assets/documents/doc10_${language}.pdf`;
    if (this.application.body.idConsent && this.application.body.cardHolderAgreement && this.application.body.privacyAdvice && this.application.body.shortFormAgreement) {
      this.readDoc10 = true;
    }
  }
  onSubmit(){
    this.modalService.dismissAll();
    this.loadingModalOn();
    let submit = true;
    if (this.configurationService.application.sendBrokerScreenToEnd && !this.application.body.altairParentAgentId &&
      this.configurationService.application.brokerEnabled) {
      submit = false;
    }
    this.applicationService.setApplication(submit).subscribe(
      (response: ApplicationBody) => {
        this.application.body.status = response.status;
        this.application.body.applicationHash = response.applicationHash;
        this.loadingModalOff();
        switch (response.status) {
          case ApplicationStatus.IN_PROGRESS:
          case ApplicationStatus.APPROVED:
          case ApplicationStatus.SUBMITTED:
            this.localStorage.set(StorageItem.COUNTRY_CODE, this.application.body.phoneCountryCode);
            let welcomeName = this.application.body.lastName;
            if (!this.application.pronounTitle ) {
              welcomeName = `${this.application.body.firstName} ${welcomeName}`;
            }
            this.localStorage.set(StorageItem.USER_INFORMATION, welcomeName);
            this.localStorage.set(StorageItem.TITLE, this.application.pronounTitle);
            if (!submit) {
              this.router.navigate(['/onboarding/addReferrer']);
            } else {
              this.router.navigate(['/onboarding/end']);
            }
            break;
          case ApplicationStatus.BLACK_LIST_DOCUMENTS:
            this.router.navigate(['/onboarding/photos']);
            break;
          case ApplicationStatus.BLACK_LIST_QUESTIONS:
            this.application.cipQ = true;
            this.application.body.cipQuestions = response.cipQuestions;
            this.router.navigate(['/onboarding/additionalQuestions']);
            break;
          default:
            this.msgError(this.translate.instant('onboarding.contracts-consents.error-try-again', {Default: 'Hubo un problema al generar su aplicación, por favor vuelva a intentarlo'}));
            break;
        }
      }, error => {
        this.loadingModalOff();
        this.msgError(error);
      });
  }

  onBack() {
    if (this.application.body.kycStatus == this.eKycStatusType.PENDING_DOCUMENTS) {
      this.router.navigate(['/onboarding/photos']);
    } else {
      if (this.isAmericanCitizen(this.application) && this.configurationService.application.enableSelfieRequiered) {
        this.router.navigate(['/onboarding/selfie']);
      } else{
        this.router.navigate(['/onboarding/personalData']);
      }
    }
  }

  onCancel() {
    this.readDoc10 = false;
    this.application.body.idConsent = null;
    this.application.body.cardHolderAgreement = null;
    this.application.body.privacyAdvice = null;
    this.application.body.shortFormAgreement = null;
  }

  onDocumentRead() {
    this.readDoc10 = true;
    this.application.body.idConsent = true;
    this.application.body.cardHolderAgreement = true;
    this.application.body.privacyAdvice = true;
    this.application.body.shortFormAgreement = true;
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-email-title'});
  }

}
